import React from 'react';
import { ReactComponent as ExportIcon } from '$/assets/icons/Export.svg';
import './index.scss';

interface IProps {
  handleExport: () => void;
  text: string;
}

const ExportButtonBase: React.FC<IProps> = ({ handleExport, text }) => {
  return (
    <div onClick={handleExport} className="export_btn" role="button">
      <div className="export_icon">
        <ExportIcon />
      </div>
      {text}
    </div>
  );
};

export default ExportButtonBase;
